import * as React from "react"

// The pan and zoom gestures themselves are shared with the review viewers (`@/lib/pan-zoom`);
// what is left here is this viewer's own range and its measure of the space it fits pages to.

export const ZOOM_MIN = 0.5
export const ZOOM_MAX = 6
export const ZOOM_STEP = 1.25

/** The element's inner width, kept current as the layout changes. */
export function useInnerWidth(ref: React.RefObject<HTMLElement | null>): number {
  const [width, setWidth] = React.useState(0)
  React.useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    const measure = () => {
      setWidth(el.clientWidth)
    }
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    return () => {
      observer.disconnect()
    }
  }, [ref])
  return width
}
